/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationDetailsOverviewResponse {
    getFixupPrototypeFunction() { return ScheduleRecommendationDetailsOverviewResponse.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationDetailsOverviewResponse>): ScheduleRecommendationDetailsOverviewResponse {
        let obj = Object.assign(new ScheduleRecommendationDetailsOverviewResponse(), model);
        ScheduleRecommendationDetailsOverviewResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationDetailsOverviewResponse>): ScheduleRecommendationDetailsOverviewResponse {
        if (!model) return null;
        return ScheduleRecommendationDetailsOverviewResponse.newInstance(<ScheduleRecommendationDetailsOverviewResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationDetailsOverviewResponse) {
        if (!obj) return;

        models.ScheduleRecommendationDetailsOverviewResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationDetailsOverviewResponse): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationDetailsOverviewResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_details) {
            models.ResourceDetailsOverview.fixupPrototype(this.resource_details);
        }
        if (this.resource_utilization_level) {
            for (let val of this.resource_utilization_level) {
                models.ResourceUtilizationOverview.fixupPrototype(val);
            }
        }
        if (this.resource_utilization_summary) {
            for (let val of this.resource_utilization_summary) {
                models.ResourceUtilizationSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource Utilization Level Overview
     */
    resource_utilization_level: Array<models.ResourceUtilizationOverview>;

    /**
     * Utilization Summary Details
     */
    resource_utilization_summary: Array<models.ResourceUtilizationSummary>;

    /**
     * Resource Details By CPU and Memory
     */
    resource_details: models.ResourceDetailsOverview;

}
